export default __webpack_public_path__ + "static/media/open-square.f6da5537.svg";